export default __webpack_public_path__ + "static/media/sidebar-2.42e96f8d.jpg";